module.exports = __webpack_public_path__ + "static/media/icon-close.3a0b33e1.svg";